import {Action} from '@ngrx/store';
import {
  DeviceMarker,
  DeviceMarkerActionResponse,
  RemoveDeviceMarkerRequest,
  SetInitialDeviceMarkersResponse
} from '../../floor-plan-shared/models/device-marker';
import {RemoveAllDeviceMarkerSuccessPayload} from '../models/floor-plan-editor-device-marker';

export enum FloorPlanEditorDeviceMarkerActionTypes {
  SetInitialDeviceMarkers = '[FloorPlanEditorDeviceMarker] Set Initial Device Markers',
  SetInitialDeviceMarkersSuccess = '[FloorPlanEditorDeviceMarker] Set Initial Device Markers Success',
  SetDeviceMarker = '[FloorPlanEditorDeviceMarker] Set Device Marker',
  AddDeviceMarkerSuccess = '[FloorPlanEditorDeviceMarker] Add Device Marker Success',
  UpdateDeviceMarkerSuccess = '[FloorPlanEditorDeviceMarker] Update Device Marker Success',
  RemoveDeviceMarker = '[FloorPlanEditorDeviceMarker] Remove Device Marker',
  RemoveDeviceMarkerSuccess = '[FloorPlanEditorDeviceMarker] Remove Device Marker Success',
  RemoveAllDeviceMarker = '[FloorPlanEditorDeviceMarker] Remove All Device Marker',
  RemoveAllDeviceMarkerSuccess = '[FloorPlanEditorDeviceMarker] Remove All Device Marker Success',
  ResetInitialEntitiesToCurrent = '[FloorPlanEditorDeviceMarker] Reset Initial Entities To Current'
}

export class SetInitialDeviceMarkers implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.SetInitialDeviceMarkers;

  constructor(public payload: DeviceMarker[]) {
  }
}

export class SetInitialDeviceMarkersSuccess implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.SetInitialDeviceMarkersSuccess;

  constructor(public payload: SetInitialDeviceMarkersResponse) {
  }
}

export class SetDeviceMarker implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.SetDeviceMarker;

  constructor(public payload: DeviceMarker) {
  }
}

export class AddDeviceMarkerSuccess implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.AddDeviceMarkerSuccess;

  constructor(public payload: DeviceMarkerActionResponse) {
  }
}

export class UpdateDeviceMarkerSuccess implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.UpdateDeviceMarkerSuccess;

  constructor(public payload: DeviceMarkerActionResponse) {
  }
}

export class RemoveDeviceMarker implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.RemoveDeviceMarker;

  constructor(public payload: RemoveDeviceMarkerRequest) {
  }
}

export class RemoveDeviceMarkerSuccess implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.RemoveDeviceMarkerSuccess;

  constructor(public payload: DeviceMarkerActionResponse) {
  }
}

export class RemoveAllDeviceMarker implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.RemoveAllDeviceMarker;
}

export class RemoveAllDeviceMarkerSuccess implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.RemoveAllDeviceMarkerSuccess;

  constructor(public payload: RemoveAllDeviceMarkerSuccessPayload) {
  }
}

export class ResetInitialEntitiesToCurrent implements Action {
  readonly type = FloorPlanEditorDeviceMarkerActionTypes.ResetInitialEntitiesToCurrent;
}

export type FloorPlanEditorDeviceMarkerActions =
  | SetInitialDeviceMarkers
  | SetInitialDeviceMarkersSuccess
  | SetDeviceMarker
  | AddDeviceMarkerSuccess
  | UpdateDeviceMarkerSuccess
  | RemoveDeviceMarker
  | RemoveDeviceMarkerSuccess
  | RemoveAllDeviceMarker
  | RemoveAllDeviceMarkerSuccess
  | ResetInitialEntitiesToCurrent;
